// Operations management, work items, and downtime components
import { defineAsyncComponent } from 'vue'

export default {
  DowntimeEvents: defineAsyncComponent(
    () => import('../downtime_events/index.vue')
  ),
  DowntimeTable: defineAsyncComponent(() => import('../downtime_table.vue')),
  FollowUp: defineAsyncComponent(() => import('../follow_up/follow_up.vue')),
  OmDashboardIndex: defineAsyncComponent(
    () => import('../om_dashboard/index_page.vue')
  ),
  OmDrilldownCommon: defineAsyncComponent(
    () => import('../om_dashboard/drilldown.vue')
  ),
  Responsible: defineAsyncComponent(
    () => import('../responsibles/responsible.vue')
  ),
  ResponsiblesIndex: defineAsyncComponent(
    () => import('../responsibles/index.vue')
  ),
  ResponsiblesShow: defineAsyncComponent(
    () => import('../responsibles/show.vue')
  ),
  WorkItemStatistics: defineAsyncComponent(
    () => import('../work_items/statistics/index.vue')
  ),
  WorkItems: defineAsyncComponent(() => import('../work_items/index.vue'))
}
